import { UserDetails } from 'state/auth/hooks/types';

export const ADOBE_ANALYTICS_PROVIDER = 'ADOBE_ANALYTICS_PROVIDER';
export const M_PARTICLE_ANALYTICS_PROVIDER = 'M_PARTICLE_ANALYTICS_PROVIDER';

export type TAnalyticsProvider =
  | typeof ADOBE_ANALYTICS_PROVIDER
  | typeof M_PARTICLE_ANALYTICS_PROVIDER;

//migrated to AnalyticsProvider events
export enum EventNames {
  PURCHASE = 'digital_revenue',
  ELEMENT_CLICKED = 'element_clicked',
  ITEM_VIEWED = 'item_view',
  ITEM_ADDED = 'item_added',
  ITEM_REMOVED = 'item_removed',
  ITEM_QUANTITY_INCREMENTED = 'item_quantity_incremented',
  ITEM_QUANTITY_DECREMENTED = 'item_quantity_decremented',
}

export interface IAnalyticsEvent {
  eventName: EventNames;
  eventType?: string;
  payload?: Record<string, any>;
}

export interface ISetCustomerIdentity {
  customerId: string;
  cognitoId: string;
  userAttributes: UserDetails['details'];
}

export interface IAnalyticsAdapter {
  logEvent: (event: IAnalyticsEvent) => void;
  setCustomerIdentity: (customerData: ISetCustomerIdentity) => void;
  logOutCustomer: () => void;
}

export type TEventCreator<T extends IAnalyticsEvent> = (payload: any) => T;

// Track the modification of item, combo slot and picker aspect.
// These values are initially false and is set to true if the user
// changes these values away from the initial state.
export interface IAddToCartSelectionAttributes {
  pickerAspectSelection: boolean;
  comboSlotSelection: boolean;
  itemModified: boolean;
}
